import {
  Box,
  Card,
  FormHelperText,
  Grid,
  InputLabel,
  Paper,
  Typography,
  useMediaQuery,
  useTheme,
  TextField,
} from "@mui/material";
import React, { useState, useEffect } from "react";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import InputField from "../../../common/InputField";
import "./CareDirective.scss";
import { PrimaryButton } from "../../../common/Buttons";
import {
  getCareDirectiveData,
  downloadPdfCareDirectiveApi,
} from "../../../services/documentServices";
import styled from "@emotion/styled";
import download from "../../../assets/images/download.png";
import {
  FormHeading,
  getUserIdFromLocalStorage,
} from "../../../utils/Utilities";
import { useTranslation } from "react-i18next";
import { Circles } from "react-loader-spinner";
import { Spinner } from "phosphor-react";

const StyledInput = styled(InputField)`
  & .MuiOutlinedInput-notchedOutline {
    border-color: #d8d8d8;
    pointer-events: "none";
  }
`;

const Overview = ({ setButtonDisabled }) => {
  let uID = getUserIdFromLocalStorage();
  const { t } = useTranslation();
  const [data, setData] = useState(null);
  const [isFetching, setIsFetching] = useState(false);
  const [initialValues, setInitialValues] = useState({
    name: "",
    generalWish: "",
    foodLike: "",
    foodDislike: "",
    drinkLike: "",
    drinkDislike: "",
    clothLike: "",
    clothDislike: "",
    jewellaryDescription: "",
    sleepHabit: "",
    music: "",
    hobby: "",
    contactLike: "",
    religionDescription: "",
    individualWish: "",
    allowanceDescription: "",
    recipientPlace: "",
  });
  const [isLoading, setIsLoading] = useState(false);

  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.down("sm"));

  const getCareDirectiveDataFun = async () => {
    setIsLoading(true);
    setButtonDisabled(true);
    try {
      const result = await getCareDirectiveData(uID);
      if (result?.success) {
        setData(result?.payLoad);
        setInitialValues({
          ...result?.payLoad,
          ...result?.payLoad?.bodyCare,
          ...result?.payLoad?.cloth,
          ...result?.payLoad?.foodDrink,
          ...result?.payLoad?.otherCareDirective,
        });
      }
    } catch (e) {
      console.log(e);
    } finally {
      setButtonDisabled(false);
      setIsLoading(false);
    }
  };

  useEffect(() => {
    getCareDirectiveDataFun();
  }, []);
  async function downloadPdf() {
    setIsFetching(true);
    const result = await downloadPdfCareDirectiveApi(uID, t);
    setIsFetching(false);
  }
  return (
    <Card className="care-directive disable-scroll documents-card-height summary-table">
      {isLoading ? (
        <Box component="div" className="loader-container">
          <Circles color="#dfc8db" height={80} width={80} />
        </Box>
      ) : (
        <Grid container>
          <Grid
            item
            lg={12}
            md={12}
            sm={12}
            xs={12}
            className="outer outer-pt-10"
          >
            <FormHeading variant="h4">{t("doc-tab-4")}</FormHeading>
            <div className="download">
              <div>
                {isFetching ? (
                  <Spinner />
                ) : (
                  <img
                    src={download}
                    height={16}
                    width={16}
                    onClick={downloadPdf}
                  />
                )}
                <Typography fontWeight={"bold"}>{t("download")}</Typography>
              </div>
            </div>
            <Typography variant="p" sx={{ mb: 4 }}>
              {t("sidebar-3-text-5")}
            </Typography>
            <div className="content">
              <Grid container>
                <Grid item lg={8} md={8} sm={12} xs={12} className="outer">
                  <Typography variant="h5" color="color.magentaDark1">
                    {t("cd-gs-text")}
                  </Typography>
                  <Formik
                    initialValues={initialValues}
                    enableReinitialize
                    onSubmit={(values) => handleSubmit(values)}
                  >
                    {(formik) => (
                      <Form>
                        <InputField
                          fullWidth
                          variant="standard"
                          placeholder="Name"
                          label="First Name, Last Name"
                          name="name"
                          type="text"
                          InputLabelProps={{ shrink: true }}
                          sx={{ mt: 2, pointerEvents: "none" }}
                        />

                        <InputLabel sx={{ mt: 2 }}>
                          {t("cd-gs-wishes")}
                        </InputLabel>
                        <FormHelperText>{t("cd-gs-eg")}</FormHelperText>
                        <InputField
                          sx={{ pointerEvents: "none" }}
                          fullWidth
                          multiline
                          rows={6}
                          variant="outlined"
                          name="generalWish"
                          type="text"
                        />
                        <br />
                        <br />
                        <Typography
                          className="paragraph"
                          color="color.magentaDark1"
                          sx={{ mb: 2 }}
                        >
                          {t("cd-fd-text")}
                        </Typography>
                        <InputLabel sx={{ mt: 2 }}>{t("cd-tab-1")}</InputLabel>
                        <FormHelperText>{t("cd-fd-eat")}</FormHelperText>
                        <StyledInput
                          sx={{ pointerEvents: "none" }}
                          fullWidth
                          multiline
                          rows={3}
                          variant="outlined"
                          name="foodLike"
                          type="text"
                        />
                        <FormHelperText sx={{ mt: 2 }}>
                          {t("cd-fd-eat-no")}
                        </FormHelperText>
                        <StyledInput
                          sx={{ pointerEvents: "none" }}
                          fullWidth
                          multiline
                          rows={3}
                          variant="outlined"
                          name="foodDislike"
                          type="text"
                        />
                        <FormHelperText sx={{ mt: 2 }}>
                          {t("cd-fd-drink")}
                        </FormHelperText>
                        <StyledInput
                          sx={{ pointerEvents: "none" }}
                          fullWidth
                          multiline
                          rows={3}
                          variant="outlined"
                          name="drinkLike"
                          type="text"
                        />
                        <FormHelperText sx={{ mt: 2 }}>
                          {t("cd-fd-drink-no")}
                        </FormHelperText>
                        <StyledInput
                          sx={{ pointerEvents: "none" }}
                          fullWidth
                          multiline
                          rows={3}
                          variant="outlined"
                          name="drinkDislike"
                          type="text"
                        />
                        <br />
                        <br />
                        <InputLabel sx={{ mt: 2 }}>{t("cd-tab-2")}</InputLabel>
                        <FormHelperText>{t("cd-cl-text-1")}</FormHelperText>
                        <InputField
                          sx={{ pointerEvents: "none" }}
                          fullWidth
                          multiline
                          rows={3}
                          variant="outlined"
                          name="clothLike"
                          type="text"
                        />
                        <FormHelperText sx={{ mt: 2 }}>
                          {t("cd-cl-text-2")}
                        </FormHelperText>
                        <InputField
                          sx={{ pointerEvents: "none" }}
                          fullWidth
                          multiline
                          rows={3}
                          variant="outlined"
                          name="clothDislike"
                          type="text"
                        />
                        <FormHelperText sx={{ mt: 2 }}>
                          {t("cd-cl-text-3")}
                        </FormHelperText>
                        <InputField
                          sx={{ pointerEvents: "none" }}
                          fullWidth
                          multiline
                          rows={3}
                          variant="outlined"
                          name="jewellaryDescription"
                          type="text"
                        />
                        <br />
                        <br />
                        <InputLabel sx={{ mt: 2 }}>
                          {t("cd-bd-text-1")}
                        </InputLabel>
                        <FormHelperText>{t("cd-bd-text-2")}</FormHelperText>
                        <InputField
                          sx={{ pointerEvents: "none" }}
                          fullWidth
                          multiline
                          rows={3}
                          variant="outlined"
                          name="bodyCareLike"
                          type="text"
                        />
                        <FormHelperText sx={{ mt: 2 }}>
                          {t("cd-bd-text-3")}
                        </FormHelperText>
                        <InputField
                          sx={{ pointerEvents: "none" }}
                          fullWidth
                          multiline
                          rows={3}
                          variant="outlined"
                          name="bodyCareWish"
                          type="text"
                        />
                        <FormHelperText sx={{ mt: 2 }}>
                          {t("cd-bd-text-4")}
                        </FormHelperText>
                        <InputField
                          sx={{ pointerEvents: "none" }}
                          fullWidth
                          multiline
                          rows={3}
                          variant="outlined"
                          name="bodyCareDislike"
                          type="text"
                        />
                        <br />
                        <br />
                        <Typography fontWeight="bold">
                          {t("rm-type-7")}
                        </Typography>
                        <FormHelperText>{t("cd-o-text-1")}</FormHelperText>
                        <InputField
                          sx={{ pointerEvents: "none" }}
                          fullWidth
                          multiline
                          rows={3}
                          variant="outlined"
                          name="sleepHabit"
                          type="text"
                        />
                        <FormHelperText sx={{ mt: 2 }}>
                          {t("cd-o-text-2")}
                        </FormHelperText>
                        <InputField
                          sx={{ pointerEvents: "none" }}
                          fullWidth
                          multiline
                          rows={3}
                          variant="outlined"
                          name="music"
                          type="text"
                        />
                        <FormHelperText sx={{ mt: 2 }}>
                          {t("cd-o-text-3")}
                        </FormHelperText>
                        <InputField
                          sx={{ pointerEvents: "none" }}
                          fullWidth
                          multiline
                          rows={3}
                          variant="outlined"
                          name="hobby"
                          type="text"
                        />
                        <FormHelperText sx={{ mt: 2 }}>
                          {t("cd-o-text-4")}
                        </FormHelperText>
                        <InputField
                          sx={{ pointerEvents: "none" }}
                          fullWidth
                          multiline
                          rows={3}
                          variant="outlined"
                          name="contactLike"
                          type="text"
                        />
                        <FormHelperText sx={{ mt: 2 }}>
                          {t("cd-o-text-5")}
                        </FormHelperText>
                        <InputField
                          sx={{ pointerEvents: "none" }}
                          fullWidth
                          multiline
                          rows={3}
                          variant="outlined"
                          name="religionDescription"
                          type="text"
                        />
                        <br />
                        <br />
                        <InputLabel sx={{ mt: 2 }}>{t("cd-tab-5")}</InputLabel>
                        <InputField
                          sx={{ pointerEvents: "none" }}
                          fullWidth
                          multiline
                          rows={3}
                          variant="outlined"
                          name="individualWish"
                          type="text"
                        />
                        <FormHelperText sx={{ mt: 2 }}>
                          {t("cd-iw-text-1")}
                        </FormHelperText>
                        <InputField
                          sx={{ pointerEvents: "none" }}
                          fullWidth
                          multiline
                          rows={3}
                          variant="outlined"
                          name="allowanceDescription"
                          type="text"
                        />
                        <Typography fontWeight="bold">
                          {t("doc-tab-3")}
                        </Typography>
                        <InputField
                          sx={{ pointerEvents: "none", mt: 2 }}
                          fullWidth
                          variant="standard"
                          //placeholder="Karlsruhe, 15th March 2022"
                          label={t("input-20")}
                          name="recipientPlace"
                          type="text"
                          InputLabelProps={{ shrink: true }}
                        />
                        <FormHelperText sx={{ mt: 2, color: "#9A9A9A" }}>
                          {t("signature-optional")}
                        </FormHelperText>
                        <Typography
                          sx={{ mt: 5, pointerEvents: "none" }}
                          variant="p"
                          paragraph
                          align="center"
                          color="color.black"
                          fontStyle="italic"
                        >
                          {t("please-sign")}
                        </Typography>
                        <TextField
                          fullWidth
                          variant="standard"
                          name="sign"
                          type="text"
                          sx={{
                            pointerEvents: "none",
                          }}
                        />
                      </Form>
                    )}
                  </Formik>
                </Grid>
              </Grid>
            </div>
          </Grid>
        </Grid>
      )}
    </Card>
  );
};

export default Overview;
